const {createMuiTheme} = require("@material-ui/core/styles")
const {default: createSpacing} = require("@material-ui/core/styles/createSpacing")

const themeName = "InDebted"
const spacing = createSpacing(4)

const colors = {
	// Brand
	deepBlue: "#020452",
	freshBlue: "#474CDE",
	mint: "#A0E9E3",

	// Notifications
	green: "#388E3C",
	orange: "#E65100",
	red: "#B00020",

	// Greyscale
	black: "#111111",
	darkGrey: "#657C97",
	lightGrey: "#F1F2FF",
	white: "#FFFFFF",
}

const palette = {
	primary: {main: colors.freshBlue, contrastText: colors.white},
	secondary: {main: colors.darkGrey, contrastText: colors.white},
}

const theme = createMuiTheme({
	themeName,
	spacing,
	palette,
	props: {
		MuiBreadcrumbs: {
			separator: "⟩",
		},
		MuiButton: {
			color: "primary",
			variant: "contained",
		},
		MuiIconButton: {
			color: "primary",
		},
		MuiListItem: {
			dense: true,
		},
		MuiTable: {
			// size: "small", // not working in prod bundle. workaround below
		},
	},
	overrides: {
		MuiBreadcrumbs: {
			li: {
				fontSize: "0.875rem",
			},
			separator: {
				color: colors.darkGrey,
				fontSize: "1.25rem",
				fontWeight: "bold",
			},
		},
		MuiContainer: {
			root: {
				padding: spacing(3),
			},
		},
		MuiTableCell: {
			body: {
				padding: "6px 24px 6px 16px", // workaround, equivalent of table size=small
			},
			head: {
				color: colors.darkGrey,
				fontSize: "0.875rem",
				padding: "6px 24px 6px 16px", // workaround, equivalent of table size=small
			},
		},
	},
})

module.exports = {theme, colors}
